import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { PlusOutlined } from '@ant-design/icons';
import { getInitialData, loginAndFetchData, refreshAndFetchData, logoutUser } from '../../features/user/userSlice';
import { Button, Col, Form, Input, Row } from 'antd';
import logo from '../../assets/images/logo.png';
import { useContext, useEffect} from 'react';
import { NotificationContext } from '../../providers/NotificationProvider';
import { useTranslation } from 'react-i18next';
import LanguageTabs from '../shared/LanguageTabs';
import { useTurnstileCaptcha } from './useTurnstileCaptcha';

type FieldType = {
  username?: string;
  password?: string;
  captcha_token?: string;
};

const LoginForm: React.FC = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const validateToken = async () => {
      const storedAccessToken = localStorage.getItem('refresh');
      if (storedAccessToken) {
        try {
          await dispatch(refreshAndFetchData(storedAccessToken) as any).then((result : any) => {
            if (getInitialData.fulfilled.match(result)) {
              navigate('/dashboard'); // Redirige al usuario a /dashboard si la autenticación es exitosa
            }
          })
          .catch((error : any) => {
            console.error('Login failed:', error);
          });
        } catch (error) {
          dispatch(logoutUser()); 
        }
      } 
    };

    validateToken();
    // eslint-disable-next-line 
  }, []);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { triggerNotification } = useContext(NotificationContext);
  const { captchaRef, captchaToken, captchaReady, resetCaptcha, turnstileSiteKey } = useTurnstileCaptcha();

  const handleSubmit = (values : any) => {
    if (!turnstileSiteKey) {
      triggerNotification('error', t('Error'), t('El captcha no está configurado.'), 'bottomRight');
      return;
    }

    if (!captchaToken) {
      triggerNotification('error', t('Error'), t('Por favor valida el captcha.'), 'bottomRight');
      return;
    }

dispatch(loginAndFetchData({ username: values.username as string, password: values.password as string, captcha_token: captchaToken }) as any)
      .then((result : any) => {
        if (getInitialData.fulfilled.match(result)) {
          navigate('/dashboard'); // Redirige al usuario a /dashboard si la autenticación es exitosa
        }
      })
      .catch((err: any) => {
        resetCaptcha();
        triggerNotification('error', t('Error'), err.message, 'bottomRight')
      });
  };

  return (
    <div className="home-login">
      <div style={{ position: 'absolute', top: 16, right: 16 }}>
        <LanguageTabs compact />
      </div>
      <Link to="/request-trial-form" className="trial-floating-tab">
        <span>{t('Solicitar Prueba')}</span>
        <PlusOutlined />
      </Link>
      <Row >
<Col className='form-login-container'>
      
      <img src={logo} alt="logo" className='logo' />
      <Form
    name="basic"
    style={{ maxWidth: 600 }}
    initialValues={{ remember: true }}
    onFinish={handleSubmit}
    autoComplete="off"
  >
      <Form.Item<FieldType>
      label={t('Usuario')}
      name="username"
      rules={[{ required: true, message: t('Por favor ingresa tu usuario.') }]}
    >
      <Input />
    </Form.Item>

    <Form.Item<FieldType>
      label={t('Contraseña')}
      name="password"
      rules={[{ required: true, message: t('Por favor ingresa tu contraseña.') }]}
    >
      <Input.Password />
    </Form.Item>

    <div className='trial-captcha-wrapper'>
      {turnstileSiteKey ? (
        <div ref={captchaRef} />
      ) : (
        <small>{t('Configura REACT_APP_TURNSTILE_SITE_KEY para habilitar el captcha.')}</small>
      )}
    </div>

    <Form.Item >
      <Button type="primary" htmlType="submit" disabled={!captchaReady && !!turnstileSiteKey}>
        {t('Iniciar Sesión')}
      </Button>
    </Form.Item>
    <Link to="/recovery-password">{t('Olvidé mi contraseña')}</Link>
  </Form>

      </Col>
      </Row>
    </div>
    
  );
};

export default LoginForm;
